import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export interface DetailRow {
  label: string;
  value?: unknown;
}

@customElement('ns-detail-list')
export class NSDetailList extends LitElement {
  @property({ type: String, reflect: true })
  layout: 'stacked' | 'grid' = 'stacked';

  @property({ attribute: false })
  rows: DetailRow[] = [];

  @property({ attribute: false })
  fallback: unknown = 'Unknown';

  static styles = css`
    :host {
      display: block;
    }

    :host([hidden]) {
      display: none;
    }

    dl {
      margin: 0;
    }

    dt,
    dd {
      margin: 0;
    }

    a {
      color: inherit;
    }

    :host([layout='stacked']) dl {
      display: flex;
      flex-direction: column;
      gap: var(--ns-detail-list-gap, var(--wa-space-m));
    }

    :host([layout='stacked']) dt {
      color: var(--ns-detail-list-label-color, color-mix(in srgb, var(--ns-theme-purple) 20%, var(--ns-theme-white)));
      text-transform: uppercase;
    }

    :host([layout='grid']) dl {
      display: grid;
      grid-template-columns: 1fr 2fr;
      gap: var(--wa-space-xs);
      font-size: var(--wa-font-size-xs);
    }

    :host([layout='grid']) .row {
      display: contents;
    }

    :host([layout='grid']) dt {
      white-space: nowrap;
    }

    :host([layout='grid']) dd {
      padding: 0 var(--wa-space-2xs);
      background: var(--primary-main-menu-background-color);
    }

    dd img {
      width: 15px;
      margin-right: var(--wa-space-2xs);
      vertical-align: middle;
    }
  `;

  private __isEmpty(value: unknown) {
    return value === undefined || value === null || value === '';
  }

  render() {
    return html`
      <dl>
        ${this.rows.map(
          (row) => html`
            <div class="row">
              <dt part="label">${row.label}</dt>
              <dd part="value">${this.__isEmpty(row.value) ? this.fallback : row.value}</dd>
            </div>
          `,
        )}
      </dl>
    `;
  }
}
